import { Selector, createSelector } from 'reselect'
import { IIntlOwnState } from '../model'
import { ILanguageSettingsState } from './models'

const branch: Selector<IIntlOwnState, ILanguageSettingsState> = (state) => state.intl.settings

export const language = createSelector(branch, (branch) => branch.language)
